// Components==============
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import Spinner from '../Spinner/Spinner';
import './Title.module.scss';
// =========================

export default function Title({
  text,
  loading,
  right,
}: {
  text: string;
  loading?: boolean;
  right?: React.ReactNode;
}) {
  const translate = useTranslate();

  return (
    <div styleName="wrapper">
      <div styleName="container">
        <h1>{translate(text)}</h1>
        <div styleName="loader-wrapper">
          <Spinner loading={loading} />
        </div>
      </div>
      {right}
    </div>
  );
}
